import { ApiClient } from "@topline/services/apiService";

export class OracleDataService {
    static componentName = "oracleDataService";
    static $inject = [ApiClient.componentName];

    constructor(
        protected apiClient: ApiClient
    ) {}

    getDictionaryData(column: string, flat?: boolean) {
        let promise;
        
        switch (column) {
            case 'brand':
                promise = this.apiClient.getOracleBrands();
                break;
            case 'market':
                promise = this.apiClient.getOracleMarkets();
                break;
            default:
                throw new Error(`Unsupported column: ${column}`);
        }
        
        return promise.then((data: string[]) => {
            if (flat) {
                return data;
            } else {
                return data.map(item => ({
                    id: item ? item : "null",
                    value: item ? item : ""
                }));
            }
        });
    }

    getRegions(market?: string) {
        return this.apiClient.getOracleRegions(market)
            .then((data: string[]) => {
                return data.map(item => ({
                    id: item ? item : "null",
                    value: item ? item : ""
                }));
            });
    }

    getBusinessUnits(region?: string) {
        return this.apiClient.getOracleBusinessUnits(region)
            .then((data: string[]) => {
                return data.map(item => ({
                    id: item ? item : "null",
                    value: item ? item : ""
                }));
            });
    }

    getLines(businessUnit?: string) {
        return this.apiClient.getOracleLines(businessUnit)
            .then((data: string[]) => {
                return data.map(item => ({
                    id: item ? item : "null",
                    value: item ? item : ""
                }));
            });
    }
}

angular.module("topline.app").service(OracleDataService.componentName, OracleDataService);